module.exports = __webpack_public_path__ + "img/plcconfig_xiazaijingxiang.2d5add85.png";